import _ from 'lodash';
import LogRocket from 'logrocket';
import template from './disableEvents.modal.html';

/* @ngInject */
function DisableEventsModalController(
  $uibModalInstance,
  $filter,
  growl,
  EquipmentService,
  selectedEquipment,
  NgTableParams
) {
  const vm = this;
  vm.equipmentIds = [];
  vm.equipmentChosen = [];

  vm.disableSelectedEvents = disableSelectedEvents;
  vm.close = close;

  vm.confirmDisable = false;
  vm.disableTime = 1;
  vm.timeOptions = [{
    value: 0,
    displayName: 'Re-enable'
  }, {
    value: 1,
    displayName: '1 Hour'
  }, {
    value: 3,
    displayName: '3 Hours'
  }, {
    value: 6,
    displayName: '6 hours'
  }, {
    value: 9,
    displayName: '9 hours'
  }];
  vm.equipmentModalInfo = {
    message: '',
    disableSelectedEvents: false
  };

  _.forEach(selectedEquipment, (equipment) => {
    if (equipment) {
      vm.equipmentIds.push(equipment.id);
      vm.equipmentChosen.push(equipment);
    }
  });

  vm.tableParams = new NgTableParams({
    page: 1,
    count: 15,
    sorting: { name: '' },
    filter: { name: '' }
  }, {
    total: vm.equipmentChosen.length,
    getData($table) {
      const params = $table._params;
      const filteredData = $table.hasFilter() ?
        $filter('filter')(vm.equipmentChosen, $table.filter()) :
        vm.equipmentChosen;
      const orderedData = $table.sorting() ?
        $filter('orderBy')(filteredData, $table.orderBy()) :
        vm.equipmentChosen;

      // set total for recalc pagination
      $table.total(orderedData.length);

      return orderedData.slice((params.page - 1) * params.count, params.page * params.count);
    }
  });

  function disableSelectedEvents() {
    vm.equipmentModalInfo.disableSelectedEvents = true;
    let growlMessage = growl.info('Disabling Events..', { disableCloseButton: true });
    EquipmentService.disableEvents(vm.equipmentIds, vm.disableTime)
      .then((success) => {
        growlMessage.destroy();
        growlMessage = growl.success(`Events ${vm.disableTime ? 'disabled' : 'enabled'}`);

        vm.equipmentModalInfo.disableSelectedEvents = false;

        $uibModalInstance.close(success.data);
      })
      .catch((res) => {
        growlMessage.destroy();
        const error = 'Error disabling events';
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
        vm.equipmentModalInfo.disableSelectedEvents = false;
      });
  }

  function close() {
    $uibModalInstance.dismiss('close');
  }
}

export default {
  template,
  controller: DisableEventsModalController,
  controllerAs: 'DisEvModCtrl'
};
